<template>

    <v-card  class="overview pb-80" elevation=0 >

        <v-card-title class="pa-0">

             <v-img  :src="bannerImg" aspect-ratio="1" class="lighten-2 " max-height="287">
                 <v-row class="fill-height align-center" style="background:rgba(0,0,0, 0.4);">
                                <v-col cols="12" md="12" sm="12" class="text-center white--text">
                                    
                                   <div >
                                       <h2 class="heading" >WELLBEING</h2>
                                        <span class="subtitle-1 pl-3 pr-3">HERE FOR YOU 24HRS 7 DAYS A WEAK</span>
                                   </div>
                                </v-col>
                                
                            </v-row>
             </v-img>

        </v-card-title>

        <v-card-text>
            <v-card class="top-card mt-50" @click="emergency">
                    <v-row class="pl-3">
                        <v-col cols="3" md="3" sm="3" class="" align="center" justify="center" >
                            <div class="fill-height d-flex align-center white-back pa-15">
                                <div class="w-100">
                                    <v-img :src="emrImg" width="42" height="48"></v-img>
                                </div>    
                            </div>
                        </v-col>
                        <v-col cols="6" md="6" sm="6" class="d-flex align-center">
                            <div class="emr-text">EMERGENCY HELP<br>
                                <span class="tap-here">Tap Here</span>
                            </div>
                            
                        </v-col>

                        <v-col cols="3" md="3" sm="3">
                            <v-img :src="tapImg" width="54" height="54"></v-img>
                        </v-col>
                    </v-row>
            </v-card>

            <v-card class="mt-3" @click="healthadvice">
                <v-row class="pl-3">
                    <v-col cols="4" md="4" sm="4" class="" align="center" justify="center" >
                        <div class="fill-height d-flex align-center icon-back pa-15">
                            <div class="w-100">
                                <v-img :src="bellImg" width="42" height="48"></v-img>
                            </div>    
                        </div>
                    </v-col>
                    <v-col cols="6" md="6" sm="6" class="d-flex align-center">
                            <div class="health-text">HEALTH ADVICE<br>
                                <span class="non">Non-Emergency</span>
                            </div>
                            
                    </v-col>

                    <v-col cols="2" md="2" sm="2" class="d-flex align-center">
                        <v-icon>mdi-arrow-right</v-icon>
                        <!-- <v-icon>mdi-medical-bag</v-icon> -->
                    </v-col>

                </v-row>
            </v-card>

            <v-card class="mt-3" @click="symptoms">
                <v-row class="pl-3">
                    <v-col cols="4" md="4" sm="4" class="" align="center" justify="center" >
                        <div class="fill-height d-flex align-center icon-back pa-15">
                            <div class="w-100">
                                <v-img :src="pharmacyImg" width="50" height="49"></v-img>
                            </div>    
                        </div>
                    </v-col>
                    <v-col cols="6" md="6" sm="6" class="d-flex align-center">
                        <div class="health-text">PHARMACY<br>
                            <span class="non">Non-Emergency</span>
                        </div>
                    </v-col>
                        
                        

                    <v-col cols="2" md="2" sm="2" class="d-flex align-center">
                        <v-icon>mdi-arrow-right</v-icon>
                        <!-- <v-icon>mdi-medical-bag</v-icon> -->
                    </v-col>

                </v-row>
            </v-card>

            <v-card class="mt-3" @click="symptoms">
                <v-row class="pl-3">
                    <v-col cols="4" md="4" sm="4" class="" align="center" justify="center" >
                        <div class="fill-height d-flex align-center icon-back pa-15">
                            <div class="w-100">
                                <v-img :src="doctorImg" width="50" height="49"></v-img>
                            </div>    
                        </div>
                    </v-col>
                    <v-col cols="6" md="6" sm="6" class="d-flex align-center">
                        <div class="health-text">DOCTOR<br>
                            <span class="non">Non-Emergency</span>
                        </div>
                        
                    </v-col>

                    <v-col cols="2" md="2" sm="2" class="d-flex align-center">
                        <v-icon>mdi-arrow-right</v-icon>
                        <!-- <v-icon>mdi-medical-bag</v-icon> -->
                    </v-col>

                </v-row>
            </v-card>

            <v-card class="mt-3">
                <v-row class="pl-3">
                    <v-col cols="4" md="4" sm="4" class="" align="center" justify="center" >
                        <div class="fill-height d-flex align-center icon-back pa-15">
                            <div class="w-100">
                                <v-img :src="toothImg" width="50" height="49"></v-img>
                            </div>    
                        </div>
                    </v-col>
                    <v-col cols="6" md="6" sm="6" class="d-flex align-center">
                        <div class="health-text">DENTIST<br>
                            <span class="non">Non-Emergency</span>
                        </div>
                        
                    </v-col>

                    <v-col cols="2" md="2" sm="2" class="d-flex align-center">
                        <v-icon>mdi-arrow-right</v-icon>
                        <!-- <v-icon>mdi-medical-bag</v-icon> -->
                    </v-col>

                </v-row>
            </v-card>

            <v-card class="mt-3">
                <v-row class="pl-3">
                    <v-col cols="4" md="4" sm="4" class="" align="center" justify="center" >
                        <div class="fill-height d-flex align-center icon-back pa-15">
                            <div class="w-100">
                                <v-img :src="physioImg" width="61" height="61"></v-img>
                            </div>    
                        </div>
                    </v-col>
                    <v-col cols="6" md="6" sm="6" class="d-flex align-center">
                        <div class="health-text">PHYSIOTHERAPIST<br>
                            <span class="non">Non-Emergency</span>
                        </div>
                        
                    </v-col>

                    <v-col cols="2" md="2" sm="2" class="d-flex align-center">
                        <v-icon>mdi-arrow-right</v-icon>
                        <!-- <v-icon>mdi-medical-bag</v-icon> -->
                    </v-col>

                </v-row>
            </v-card>

            <v-card class="mt-3">
                <v-row class="pl-3">
                    <v-col cols="4" md="4" sm="4" class="" align="center" justify="center" >
                        <div class="fill-height d-flex align-center icon-back pa-15">
                            <div class="w-100">
                                <v-img :src="chiroImg" width="61" height="61"></v-img>
                            </div>    
                        </div>
                    </v-col>
                    <v-col cols="6" md="6" sm="6" class="d-flex align-center">
                        <div class="health-text">CHIROPRACTOR<br>
                            <span class="non">Non-Emergency</span>
                        </div>
                        
                    </v-col>

                    <v-col cols="2" md="2" sm="2" class="d-flex align-center">
                        <v-icon>mdi-arrow-right</v-icon>
                        <!-- <v-icon>mdi-medical-bag</v-icon> -->
                    </v-col>

                </v-row>
            </v-card>

        </v-card-text>

    </v-card>

    
</template>
<script>
import Vue from 'vue'
import { EventBus } from '@/event-bus';
export default {
    props: ['business','tag']  ,

  data: () => ({
    bannerImg:require('@/assets/health.jpg'),
    emrImg:require('@/assets/emergency.png'),
    tapImg:require('@/assets/tap.png'),
    bellImg:require('@/assets/bell.png'),
    pharmacyImg:require('@/assets/pharmecy.png'),
    doctorImg:require('@/assets/doctor.png'),
    toothImg:require('@/assets/tooth.png'),

    physioImg:require('@/assets/PHYSIOTHERAPIST.png'),
    chiroImg:require('@/assets/CHIROPRACTOR.png'),
    
    
    }),
  methods: 
   {
       emergency()
       {
           this.$router.push({name:'emergency'});
           this.activeBtn=0;
       },
       symptoms()
       {
           this.$router.push({name:'symptoms'});
           this.activeBtn=0;

       },
       healthadvice()
       {
        //    this.$router.push({name:'healthadvice'});
        //    this.activeBtn=0;
        
         EventBus.$emit('healthadvicedetail',141);
       }

   }
}
</script>
<style>
.top-card.theme--light.v-card
{
    background: #D80027 !important;
}
.white-back{
    background: #fff !important;
}
.pa-15
{
    padding: 15px;
}
.emr-text
{
    color: #FEC83D;
    font-size:16px;
    font-weight: bold;
}
.tap-here
{
    color: #FEC83D;
    font-size:14px;
}
.icon-back
{
    background: rgba(237, 240, 242, 0.5);
}
.health-text{
    color: #000;
    font-size:16px;
    font-weight: bold;
}
.non
{
    color: #e8e8e8;
    font-size:14px;
}
.mt-50{
    margin-top:-50px;
}
</style>